<template>

  <div class="col-lg-10 col-lg-offset-1">
    <div class="hpanel">
      <div class="panel-heading">
        Visitor Reports
      </div>
      <div class="panel-body">
        <div class="table-responsive">
          <vue-good-table
            :columns="columns"
            :rows="[]"
            :paginate="true"
            :globalSearch="true"
            :lineNumbers="true"
            styleClass="table table-responsive table-bordered table-stripped"
          >
            <template slot="table-row" slot-scope="props">
            </template>
          </vue-good-table>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      columns: [
        {
          label: 'Visitor',
          field: ''
        },
        {
          label: 'Purpose',
          field: ''
        },
        {
          label: 'Date',
          field: ''
        },
        {
          label: 'Time In',
          field: ''
        },
        {
          label: 'Time Out',
          field: ''
        },
        {
          label: 'Vehicle Plate',
          field: ''
        },
        {
          label: 'Handler',
          field: ''
        }
      ]
    }
  }
}
</script>

<style>

</style>
